import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from '../Spinner/SpinnerNew';
import MicroFrontendContainer from './MicrofrontendContainer';
import {
  getCreateSeqNum,
  getAllCommentCorrListForCommonPoc,
  getGeneralSystemParameterDetails,
  getLinksTableData,
  postSaveOrUpdateForCommonPoc,
  postSingleDeleteCommentForCommonPoc,
  clearReduxForCommCorrespondencePopup,
} from '../../Modules/System/commentsAndCorrespondence/store/Actions';
import {
  commentCorrTableHead,
  linkTabTableHead,
} from '../../Modules/System/commentsAndCorrespondence/components/gridComponents/tableHead';
import { getCommonDropdownList } from '../CommonUtilities/commonUtilities';
import { checkActionAccessByRole } from '../utilities/utilities';

export default function CommentAndCorrespondenceComponent(props) {
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const [hasAccess, setHasAccess] = React.useState(
    !checkActionAccessByRole(process.env.REACT_APP_COMMENTS_CORR_ROLE, kcRoles)
  );
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const dispatch = useDispatch();
  const fetchAllCommentList = (value) => {
    return dispatch(getAllCommentCorrListForCommonPoc(value));
  };
  const fetchGenerateSeqNum = (value) => {
    return dispatch(getCreateSeqNum(value));
  };
  const getLinksTableDataInfo = (value) => {
    return dispatch(getLinksTableData(value));
  };
  const deleteSingleComment = (value) => {
    return dispatch(postSingleDeleteCommentForCommonPoc(value));
  };

  const getCorrCommentSeqNumber = useSelector((state) => {
    return state.sharedState.CommentsReducer.createNewSeqComId;
  });
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.CommentListData?.sort(
      (a, b) => b.corrCommentId - a.corrCommentId
    );
  });
  const FetchAllCommentsLinkList = useSelector((state) => {
    return state.sharedState.CommentsReducer.commentsLinkData;
  });
  const saveOrUpdateMessage = useSelector((state) => {
    return state.sharedState.CommentsReducer.saveOrUpdateMessageByCommonPoc;
  });
  const generalSystemParameterDetails = useSelector((state) => {
    return state.sharedState.CommentsReducer.generalSystemParameter
      .paramGeneralVO;
  });
  const isSystemParameter =
    generalSystemParameterDetails?.length > 0 &&
    parseInt(generalSystemParameterDetails[0]?.preventCcUpdateInd, [0, 1]) ===
      1;
  const { corrLinkId, linkTableName, setShowComments, rowGridPrimaryKey } =
    props;
  const [spinnerLoader, setSpinnerLoader] = React.useState();
  const [commentsData, setCommentsData] = React.useState();
  const [commonDropdownList, setCommonDropdownList] = React.useState([]);

  const [createNewSeqComId, setCreateNewSeqComId] = React.useState(
    getCorrCommentSeqNumber
  );
  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, [kcRoles]);
  React.useEffect(() => {
    dispatch(getGeneralSystemParameterDetails());
    if (corrLinkId) {
      setSpinnerLoader(true);
      getCommonDropdownList({
        codeDomainList: [
          'CORR_METHOD_CD',
          'CORR_TYPE_CD',
          'CHECK_PAYEE_CD',
          'PAYMENT_MEDIA_TYPE_CD',
          'DISPUTE_RESOLUTION_CD',
        ],
      }).then((res) => {
        setCommonDropdownList(res);
      });
      fetchAllCommentList(null);
      fetchAllCommentList({
        corrLinkId: corrLinkId === -1 ? 0 : corrLinkId,
        linkTableName: linkTableName,
        rowGridPrimaryKey: rowGridPrimaryKey || 0,
      });
      getLinksTableDataInfo({
        linkTableName: linkTableName,
        corrLinkId: corrLinkId === -1 ? 0 : corrLinkId,
        rowGridPrimaryKey: rowGridPrimaryKey || 0,
      });
    } else {
      setShowComments(false);
    }
  }, []);
  React.useEffect(() => {
    setCommentsData(commentsList);
    if (window.updateInjectableProps) {
      window.updateInjectableProps(commentsList);
    }
  }, [commentsList]);
  React.useEffect(() => {
    setCreateNewSeqComId(getCorrCommentSeqNumber);
    if (window.updateInjectableProps) {
      window.updateInjectableProps(
        commentsList,
        null,
        null,
        getCorrCommentSeqNumber
      );
    }
  }, [getCorrCommentSeqNumber]);
  React.useEffect(() => {
    if (commonDropdownList?.CORR_METHOD_CD?.length > 0) {
      setTimeout(() => {
        setSpinnerLoader(false);
      }, 100);
    }
  }, [commonDropdownList?.CORR_METHOD_CD?.length > 0]);
  React.useEffect(() => {
    if (saveOrUpdateMessage && saveOrUpdateMessage.message === 'SUCCESS') {
      fetchAllCommentList({
        corrLinkId: corrLinkId === -1 ? 0 : corrLinkId,
        linkTableName: linkTableName,
        rowGridPrimaryKey: rowGridPrimaryKey || 0,
      });
      getLinksTableDataInfo({
        linkTableName: linkTableName,
        corrLinkId: corrLinkId === -1 ? 0 : corrLinkId,
        rowGridPrimaryKey: rowGridPrimaryKey || 0,
      });
      if (window.updateInjectableProps) {
        window.updateInjectableProps(null, saveOrUpdateMessage, null);
      }
    } else if (saveOrUpdateMessage === 'failed') {
      if (window.updateInjectableProps) {
        window.updateInjectableProps(commentsList, null, saveOrUpdateMessage);
      }
    }
  }, [saveOrUpdateMessage]);
  const saveUpdateComment = (saveRequest) => {
    const newObj = saveRequest;
    newObj.commentLinkDefTableVOList = Array.isArray(
      newObj.commentLinkDefTableVOList
    )
      ? newObj.commentLinkDefTableVOList
      : [];
    dispatch(postSaveOrUpdateForCommonPoc(newObj));
  };
  const generateNewCorrCommentSeqNum = () => {
    fetchGenerateSeqNum({});
  };

  return (
    <div>
      <Spinner load={spinnerLoader} />
      {spinnerLoader !== undefined && !spinnerLoader ? (
        <MicroFrontendContainer
          id="plan-search-cri-comments"
          type="InjectableComments"
          setShowComments={setShowComments}
          setOpenPopup={(val) => {
            if (!val) {
              dispatch(clearReduxForCommCorrespondencePopup());
            }
          }}
          linkTabTableHead={linkTabTableHead}
          commentTableHead={commentCorrTableHead}
          commonDropdownList={commonDropdownList}
          commentsList={commentsData}
          getCorrCommentSeqNumber={createNewSeqComId}
          linkTableName={linkTableName}
          commentsLinksData={FetchAllCommentsLinkList}
          corrLinkId={corrLinkId}
          isSystemParameter={isSystemParameter}
          UserDefaultValues={UserDefaultValues}
          saveUpdateComment={saveUpdateComment}
          deleteSingleCommentCorr={deleteSingleComment}
          fetchAllCommentList={fetchAllCommentList}
          generateNewCorrCommentSeqNum={generateNewCorrCommentSeqNum}
          rowGridPrimaryKey={rowGridPrimaryKey || 0}
          hasAccess={hasAccess}
          isEnablebyRole={isEnablebyRole}
        />
      ) : null}
    </div>
  );
}
